
<template> 
    <CardRh :processando="processando">   
        <div class="row g-6 g-xl-12 my-5 mx-5"   >  
            <ListaCampoForm :campos="campos" :formulario="formulario"  :disabled="true" ></ListaCampoForm>  
        </div>   
    </CardRh> 
</template>

<script lang="ts">   
    import CardRh from   "@/components/cards/ManzaCard.vue"  
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import {  Prop , Watch  } from 'vue-property-decorator';   
    import {  Disciplina } from "@/views/paginas/sigap/turma/disciplinas/Disciplina"; 
    import EixoService from   "@/service/v1/sigap/EixoService"   
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
     

    @Options({
        name: "DisciplinaShow",
        components: {  ListaCampoForm, CardRh   },   
    }) 
    export default class DisciplinaShow extends Vue {
        
        @Prop( ) readonly disciplina!: any

        public campos: Array<any> = [ ];
        public formulario: any  = { } ;  

        @authStore.Getter
		public perfis!: any  
   
        public eixoService = new EixoService();

        public processando = false ; 
          
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
        
        async created() {  
            this.campos =  Disciplina.campos();  
            await this.buscarEixo(); 
            this.modeloAlterado();
        }

        @Watch('turma')
        public modeloAlterado(){   
            this.formulario = {}
            if(this.disciplina){   
                this.formulario =  JSON.parse(JSON.stringify( this.disciplina ));    
                this.formulario.tipo = this.formulario.tipo.id;
                this.formulario.status = this.formulario.status.id;
            } 
        }
        
        public async buscarEixo(){   
            await this.eixoService.getAll( "take=100&turmaId=" +  this.disciplina.turmaId ).then(response =>{ 
               this.campos.unshift(
                    {
                        nome: "eixoId",
                        type: "select",
                        label: "Eixo",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.data.map((item) => { return { value: item.id, label: item.descricao } })
                    },
                );
            });
        }
  
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    } 
    .start-90{
        left: 97% !important;
    } 
    .col-12{
        margin-bottom: 40px;
    } 
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    } 
</style>
